import * as AddToBasket from '@ori-events/add-to-basket';
import * as LoyaltyDialogResult from '@ori-events/loyalty-dialog-result';

import addToBasket from '../helpers/addToBasket';
import { RequestUrl } from '../models';

export default ({ detail }: LoyaltyDialogResult.Event) => {
  const { result } = detail;

  if (LoyaltyDialogResult.isLoyaltyCloseResult(result)) {
    return false;
  }

  if (LoyaltyDialogResult.isLoyaltyBuyForPointsResult(result)) {
    const { catalogueItemId, choiceId, itemCode, quantity, placement } = detail;

    return addToBasket(
      RequestUrl.AddToBasketForPoints,
      {
        itemCode,
        quantity,
        choiceId,
        catalogueItemId,
        placement,
      },
      AddToBasket.Method.BUY_FOR_POINTS,
    );
  }

  if (LoyaltyDialogResult.isLoyaltyBuyForMoneyResult(result)) {
    const { itemCode, quantity, originalItemCode, replacementType, placement } = detail;

    return addToBasket(
      RequestUrl.AddToBasketForMoney,
      {
        itemCode,
        quantity,
        originalItemCode,
        replacementType,
        placement,
      },
      AddToBasket.Method.BUY_FOR_MONEY,
    );
  }

  return false;
};
